import React from 'react'
import CandidateDashboardNav from '../../candidate/CandidateDashboardNav'
import { Link } from 'react-router-dom'
// import Breadcrumb from '../common/Breadcrumb'
import Breadcrumb from '../../Breadcrumb'

const SortListedJobs = () => {
  return (
    <>
    {/* <Breadcrumb pagename='Shortlisted Jobs'/> */}
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Shortlisted Jobs</h2>
          <ul className="breadcrumb-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Shortlisted Jobs</li>
          </ul>
        </div>
      </div> */}
      <Breadcrumb
        title="Shortlisted Jobs"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Shortlisted Jobs", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <CandidateDashboardNav />
            {/* here page will is design */}
            <div>Design </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SortListedJobs
